"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOxygen = exports.OxygenProvider = exports.OxygenContext = exports.themeNames = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = require("styled-components");
const oxygen_theme_1 = __importDefault(require("@8x8/oxygen-theme"));
exports.themeNames = {
    light: 'light',
    dark: 'dark',
    classic: 'classic',
};
// there is no theme name for "classic", we are going to use "novo" as default
// if you use the new provider you will only have the new design system on the context
const themeMapping = {
    light: 'novo',
    dark: 'novoDark',
    classic: 'novo',
};
/**
 * Use `undefined` as default value to differentiate between project using
 * the Provider and projects not using it.
 * */
exports.OxygenContext = (0, react_1.createContext)(undefined);
const OxygenProvider = ({ themeName = 'light', globalComponentsOverride, theme, children, }) => {
    // if a custom theme object is presented use that
    // otherwise use the Oxygen provided themes (novo or novoDark) based on the themeName
    // classic returns novo — there is no classic with usage of <OxygenProvider />
    const selectedTheme = theme || oxygen_theme_1.default[themeMapping[themeName]];
    const contextValue = react_1.default.useMemo(() => ({
        // @todo open question: do we still want/need themeName if a custom theme object is provided?
        // should this come from the custom theme object instead?
        themeName,
        globalComponentsOverride,
        theme: selectedTheme,
    }), [themeName, globalComponentsOverride, selectedTheme]);
    return (react_1.default.createElement(exports.OxygenContext.Provider, { value: contextValue },
        react_1.default.createElement(styled_components_1.ThemeProvider, { theme: selectedTheme }, children)));
};
exports.OxygenProvider = OxygenProvider;
const useOxygen = () => react_1.default.useContext(exports.OxygenContext);
exports.useOxygen = useOxygen;
